import React, { useEffect, useState } from "react";
import "./profileMenu.scss";
import settingIcon from "../../assets/Icons/settings_icon.svg";
import personIcon from "../../assets/Icons/person_icon.svg";
import languageIncon from "../../assets/Icons/language_icon.svg";
import checkIcon from "../../assets/Icons/check_icon.svg";
import logoutIcon from "../../assets/Icons/logout_icon.svg";
import keyAccessIcon from "../../assets/Icons/key_access_icon.svg";
import authService, {
  getUserCompanyName,
  updateInfoCompanies,
} from "../../services/authService";
import { useNavigate } from "react-router-dom";
import { use } from "react";

export const ProfileMenu = ({ menuVisible, hiddeMenuFunction }) => {
  const languages = [
    {
      language: "English , United States",
    },

    {
      language: "Español , Latinoámerica",
    },
  ];
  const { getUsername } = authService();
  const [companyList, _] = useState(
    JSON.parse(localStorage.getItem("u_companies"))
  );
  const [languageSelected, setLanguageSelected] = useState(
    languages[0].language
  );
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [theme, setTheme] = useState("light");
  const [viewProfileMenu, setViewProfileMenu] = useState(menuVisible);
  const { logOut } = authService();
  const [userName, setUserName] = useState("user");
  const [userAchronym, setUserAchronym] = useState("U");
  const [companyName, setCompanyName] = useState("");
  const navigate = useNavigate();

  // functions
  const handleLogoutOutlook = () => {
    // const closeSession = logOut();
    // if (closeSession === 200) {
    // navigate("/login");
    // } else {
    //   // what can i show?
    // }
    logOut();
    navigate("/login");
  };

  const getName = () => {
    const name = getUsername();
    if (name) {
      setUserName(name);
    } else {
      setUserName("Unknow name");
    }
  };

  const getCompanyName = () => {
    const comp_name = getUserCompanyName();
    if (comp_name) {
      setCompanyName(comp_name);
    } else {
      setCompanyName("Unknow company");
    }
  };

  useEffect(() => {
    if (!selectedCompany) return;
    if (selectedCompany.isSelected) return;
    updateInfoCompanies({
      id: selectedCompany.idRelation,
      user: {
        id: parseInt(localStorage.getItem("u_id")),
      },
      company: {
        id: selectedCompany.id,
      },
      isSelected: true,
    })
      .then((res) => {
        const companies = JSON.parse(localStorage.getItem("u_companies"));
        companies.map((e) => {
          if (e.id === selectedCompany.id) {
            e.isSelected = true;
          } else {
            e.isSelected = false;
          }
        });
        localStorage.setItem("u_companies", JSON.stringify(companies));
        localStorage.setItem("u_company_id", selectedCompany.id);
        localStorage.setItem("u_company_name", selectedCompany.name);
        setCompanyName(selectedCompany.name);
        window.location.reload();
      })
      .catch((error) => console.error(error));
  }, [selectedCompany]);
  const createAchronym = () => {
    const name = getUsername();
    if (name) {
      const split = name.trim().split(" ");

      const acronym = split
        .slice(0, 1)
        .map((word) => word.charAt(0).toUpperCase())
        .join("");
      setUserAchronym(acronym);
    }
  };

  useEffect(() => {
    setViewProfileMenu(menuVisible);
  }, [menuVisible]);

  useEffect(() => {
    getName();
    getCompanyName();
    createAchronym();
  }, []);

  const handleThemeSelected = (theme) => {
    setTheme(theme);
  };

  const selectLanguage = (language) => {
    setLanguageSelected(language.language);
  };

  return (
    <menu
      className={`user-profile-menu bg-white ${
        viewProfileMenu ? "" : "hidde-menu"
      }`}
      onMouseLeave={hiddeMenuFunction}
    >
      <section className="top-menu-profile ">
        <div className="menu-profile-username-cont ">
          <section className=" username-section ">
            <h4 className="txt-black-mid ellipsis">Welcome , {userName}</h4>
            <div className="select-company">
              <p className="txt-black-mid hiperlink-company">
                {companyName} 
                {/* {companyList && companyList.length > 1 && <i className="icon-arrow-down"> </i>} */}
              </p>
              {/* {companyList && companyList.length > 1 && (
                <section className="menu-list-companies">
                  {companyList.map((e, index) => {
                    return (
                      <span key={index} onClick={() => setSelectedCompany(e)}>
                        {e.name}
                      </span>
                    );
                  })}
                </section>
              )} */}
            </div>
          </section>

          <section className="username-achronym">
            <span className={"txt-white"} onClick={()=>hiddeMenuFunction()}>{userAchronym}</span>
          </section>
        </div>

        <div className="menu-profile-position-cont">
          <span>
            <p className="txt-grey-100">Position</p>
            <p className="txt-black-mid">Chief Executive Officer (CEO)</p>
          </span>
          <span>
            <p className="txt-grey-100">Department</p>
            <p className="txt-black-mid">Administrative</p>
          </span>
          <button className="txt-black-mid">More Details</button>
        </div>

        <div className="menu-profile-configuration-cont">
          <span className="bg-white-100">
            <img src={settingIcon} alt="" />
            <p
              className="txt-black-mid"
              style={{ fontSize: ".6rem", fontWeight: "500" }}
            >
              Configuration
            </p>
          </span>
          <span className="bg-white-100 bg-white-100">
            <img src={personIcon} alt="" />
            <p className="txt-black-mid">Screen Configuration</p>
          </span>
          <span className="span-select-language bg-white-100">
            <img src={languageIncon} alt="" />
            <div className="select-language">
              <span className="txt-grey-100">Change Language</span>
              <p className="txt-black-mid">{languageSelected}</p>
              <section className="languages-availables">
                {languages.map((e, index) => {
                  return (
                    <span key={index} onClick={() => selectLanguage(e)}>
                      {e.language}
                    </span>
                  );
                })}
              </section>
            </div>
          </span>
          <span className="theme-selector">
            <p className="txt-black-mid" style={{ fontSize: ".7rem" }}>
              Theme selector
            </p>
            <div>
              <button
                className={`light-theme bg-white-mid ${
                  theme == "light" ? "light-btn-selected" : ""
                }`}
                onClick={() => handleThemeSelected("light")}
              >
                <img src={checkIcon} alt="" />
              </button>
              <button
                className={`dark-theme bg-black-mid ${
                  theme == "dark" ? "dark-btn-selected" : ""
                }`}
                onClick={() => handleThemeSelected("dark")}
              >
                <img src={checkIcon} alt="" />
              </button>
            </div>
          </span>
        </div>
      </section>

      <section className="bottom-menu-profile">
        <div className="bg-white-100">
          <p className="txt-black-mid">Request Access</p>
          <img src={keyAccessIcon} alt="" />
        </div>
        <div className="bg-white-100" onClick={handleLogoutOutlook}>
          <p className="txt-black-mid">Logout</p>
          <img src={logoutIcon} alt="" />
        </div>
      </section>
    </menu>
  );
};
